import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import { ToastrService } from 'ngx-toastr';

import axios from "src/app/Service/axios";

@Component({

  selector: 'app-ayab-zahab',

  templateUrl: './ayab-zahab.component.html',

  styleUrls: ['./ayab-zahab.component.css']

})

export class AyabZahabComponent implements OnInit {

  iPassengers: number = 0;

  lst_Report: any = [];

  lst_Search: any = [];

  mdl_Request: FormGroup = this.formBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSubject: new FormControl(''),

    strUnitID: new FormControl(''),

    strType: new FormControl(''),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

  });

  constructor(

    private notifyService: NotificationService,

    private router: Router,

    private otherService: OtherService,

    private formBuilder: FormBuilder,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _toastr: ToastrService

  ) { }

  ngOnInit(): void {

    this.route.params.subscribe(params => {

      this.mdl_Request.patchValue({

        strSubject: params['type'] == 1 ? 'گزارش مسافرین فعلی' : 'گزارش سرجمع مسافرین',

        strUnitID: params['id'],

        strType: params['type'],

      });

      setTimeout(() => {

        this.get_Report();

      }, 100);

    });

  }

  get_Report = async () => {

    this.otherService.Showspinner();

    const model = this.otherService.stringNumberToNumber(this.mdl_Request.value);

    const ENDPOINT = model.strType == 1 ? 'Route_FunctionReport_Passenger_Temp_BoardedNow' : 'Route_FunctionReport_Passenger_Report_TotalByDate';

    const resp = await axios.post(ENDPOINT, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) return this._toastr.error(res.strError)

    this.lst_Report = res;

    this.lst_Search = res;

    if (model.strType == 2) {

      this.iPassengers = 0;

      this.lst_Report.forEach((el: any) => {
  
        this.iPassengers += el.iPassengers
  
      })

    }

  }

  filter_list(val: any) {

    this.lst_Report = this.lst_Search.filter((el: any) => {

      return el.strName.includes(val.value) ||

        el.strFamily.includes(val.value) ||

        el.strDate.includes(val.value) ||

        el.strDayName.includes(val.value) ||

        el.strMobileType_strComment.includes(val.value) ||

        el.strMobileType_strComment.includes(val.value) ||

        el.strFullName.includes(val.value) ||

        el.strRoute_Stations_strName.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Report = this.lst_Search;

    }


  }

}
